import { ONBOARDING_THREAD_ID } from '@/utils/constants';

export const onboardingMessagesDE = {
  'step-0': {
    messages: {
      role: 'ai',
      content: [],
    },
  },
  'step-1': {
    messages: {
      role: 'ai',
      content: [
        {
          id: 'onb-0',
          timestamp: '2024-11-21T06:35:39.224335+00:00',
          role: 'human',
          threadId: ONBOARDING_THREAD_ID,
          content:
            'DEMO: Welche Fahrer benötigen Unterstützung aufgrund einer Gesamtbewertung unter 70 im Durchschnitt im vergangenen Monat und wie lauten ihre Bewertungen?',
        },
        {
          id: 'onb-1',
          timestamp: '2024-11-21T06:36:09.224354+00:00',
          role: 'ai',
          threadId: ONBOARDING_THREAD_ID,
          data_visualization: {
            default_data_visualization: 'table',
            x_axis: 'Fahrer Name',
          },
          content:
            'Im Zeitraum vom 1. Juni 2026 bis 30. Juni 2026 wurden 12 Fahrer mit einer durchschnittlichen Gesamtbewertung unter 70 identifiziert.\n\n' +
            '```json\n\n' +
            '{"table": [{"Fahrer Name": "Lucas Auernhammer", "Gesamtbewertung": 23.0}, {"Fahrer Name": "Christian Scheunemann", "Gesamtbewertung": 25.0}, {"Fahrer Name": "Bruno Ranft", "Gesamtbewertung": 26.0}, {"Fahrer Name": "Ute Meyjohann", "Gesamtbewertung": 26.0}, {"Fahrer Name": "Erhard Brauer", "Gesamtbewertung": 28.0}, {"Fahrer Name": "Margit Br\\u00fcck", "Gesamtbewertung": 28.0}, {"Fahrer Name": "Torsten Mustermann", "Gesamtbewertung": 39.0}, {"Fahrer Name": "Marius Mehl", "Gesamtbewertung": 42.0}, {"Fahrer Name": "Thomas Mustermann", "Gesamtbewertung": 43.0}, {"Fahrer Name": "Bernd M\\u00fcller", "Gesamtbewertung": 44.0}, {"Fahrer Name": "Maik Fleischhauer", "Gesamtbewertung": 44.0}, {"Fahrer Name": "Sabine Lindenmann", "Gesamtbewertung": 48.0}]}\n```' +
            '\n\nDa die Frage explizit nach Fahrern fragt, die Unterstützung benötigen, folgt eine detaillierte Analyse:\n\n' +
            '**Kritischer Bereich (unter 30 Punkte):**\n\n' +
            'Lucas Auernhammer, Christian Scheunemann, Bruno Ranft, Ute Meyjohann, Erhard Brauer und Margit Brück weisen die niedrigsten Gesamtbewertungen auf und haben den dringendsten Handlungsbedarf. Für diese Fahrer wird eine sofortige individuelle Betreuung empfohlen.\n\n' +
            '**Mittlerer Bereich (30–50 Punkte):**\n\n' +
            'Torsten Mustermann, Marius Mehl, Thomas Mustermann, Bernd Müller, Maik Fleischhauer und Sabine Lindenmann liegen im mittleren Bereich. Auch sie liegen deutlich unter dem Zielwert von 70 Punkten und sollten gezielt gefördert werden.\n\n' +
            '**Empfohlene Maßnahmen:**\n\n' +
            '- Gezielte Einzelcoachings für Fahrer im kritischen Bereich, insbesondere zu den Bereichen Segeln, Bremsen, Tempomat-Nutzung und Geschwindigkeitsüberschreitung.\n\n' +
            '- Regelmäßige Leistungsüberprüfungen, um Fortschritte zu verfolgen.\n\n' +
            '- Einsatz des MAN ProfiDrive Trainingsprogramms oder des Connected CoDriver zur kontinuierlichen Effizienzverbesserung im Fahralltag.',
        },
      ],
    },
  },

  'step-2': {
    messages: {
      role: 'ai',
      content: [
        {
          id: 'onb-2',
          timestamp: '2024-11-21T06:36:39.224360+00:00',
          role: 'human',
          threadId: ONBOARDING_THREAD_ID,
          content: 'Was ist der Grund für die niedrige Bewertung von Bruno Ranft?',
        },
        {
          id: 'onb-3',
          timestamp: '2024-11-21T06:37:09.224366+00:00',
          role: 'ai',
          threadId: ONBOARDING_THREAD_ID,
          data_visualization: {
            default_data_visualization: 'table',
          },
          content:
            'Hier sind die detaillierten Bewertungen von Bruno Ranft für den Zeitraum vom 1. Juni 2026 bis 30. Juni 2026:\n\n' +
            '```json\n\n' +
            '{"table": [{"KPI": "Fahrer Name", "": "Bruno Ranft"}, {"KPI": "Bewertung Schubbetrieb", "": 20.0}, {"KPI": "Bewertung des Bremsverhaltens", "": 20.0}, {"KPI": "Gaspedal-Bewertung", "": 40.0}, {"KPI": "Bewertung Einsatz Geschwindigkeitsregelung", "": 50.0}, {"KPI": "Bewertung Overspeed", "": 0.0}]}\n```' +
            '\n\nDie Ergebnisse zeigen, dass Bruno Ranft in allen fünf Bewertungskategorien niedrige Werte erzielt hat, wobei die Bewertung für Geschwindigkeitsüberschreitung (Overspeed) mit 0,0 besonders auffällt.\n\n' +
            '**Analyse der Schwachstellen:**\n\n' +
            '**Geschwindigkeitsüberschreitung (0,0):** Dies ist der kritischste Bereich. Eine Bewertung von 0,0 deutet darauf hin, dass Bruno Ranft regelmäßig die zulässigen Höchstgeschwindigkeiten überschreitet. Dies hat direkte Auswirkungen auf Sicherheit und Kraftstoffverbrauch.\n\n' +
            '**Schubbetrieb / Segeln (20,0):** Der Schubbetrieb wird kaum genutzt. Das Fahrzeug rollt selten im Segelmodus aus, was auf eine ineffiziente Fahrweise hindeutet und den Kraftstoffverbrauch erhöht.\n\n' +
            '**Bremsverhalten (20,0):** Häufiges oder abruptes Bremsen deutet darauf hin, dass vorausschauendes Fahren verbessert werden sollte. Eine bessere Nutzung des Schubbetriebs würde auch die Bremsbewertung positiv beeinflussen.\n\n' +
            '**Gaspedal-Bewertung (40,0):** Die Gaspedalnutzung ist ebenfalls verbesserungswürdig, was auf ein aggressiveres Beschleunigungsverhalten hindeutet.\n\n' +
            '**Tempomat-Nutzung (50,0):** Der Tempomat wird nur in etwa der Hälfte der geeigneten Situationen eingesetzt. Eine konsequentere Nutzung würde sowohl die Bewertung als auch den Kraftstoffverbrauch verbessern.\n\n' +
            '**Empfohlene Maßnahmen:**\n\n' +
            '- Priorität sollte auf der Reduzierung von Geschwindigkeitsüberschreitungen liegen, da dies den größten Einfluss auf die Gesamtbewertung hat.\n\n' +
            '- Das MAN **ProfiDrive**-Trainingsprogramm oder der **Connected CoDriver** können Bruno Ranft gezielt bei der Verbesserung des vorausschauenden Fahrens, der Tempomat-Nutzung und der Geschwindigkeitseinhaltung unterstützen.\n\n' +
            '- Regelmäßige Leistungsüberprüfungen helfen dabei, Fortschritte zu verfolgen und den Coaching-Bedarf anzupassen.',
        },
      ],
    },
  },

  'step-3': {
    messages: {
      role: 'ai',
      content: [
        {
          id: 'onb-4',
          timestamp: '2024-11-21T06:37:39.224372+00:00',
          role: 'human',
          threadId: ONBOARDING_THREAD_ID,
          content: 'Wie setzt sich die Bremsleistung zusammen?',
        },
        {
          id: 'onb-5',
          timestamp: '2024-11-21T06:38:09.224378+00:00',
          role: 'ai',
          threadId: ONBOARDING_THREAD_ID,
          content:
            'Die **Bremsbewertung** setzt sich aus zwei Kriterien zusammen:\n\n' +
            '**1. Verhältnis verschleißfreie Bremse zur Betriebsbremse**\n\n' +
            'Es wird verglichen, wie viel des abgebremsten Weges mit der **Motorbremse oder dem Retarder** (verschleißfrei) gegenüber der **Betriebsbremse** zurückgelegt wurde.\n\n' +
            '**2. Anteil der Betriebsbremse an der Gesamtfahrstrecke**\n\n' +
            'Der Anteil der Strecke, auf dem die Betriebsbremse eingesetzt wurde, wird in Relation zur Gesamtfahrstrecke betrachtet.\n\n' +
            '---\n\n' +
            '**Bewertungsgrenzen:**\n\n' +
            '- **100 %:** Verhältnis verschleißfreie Bremse zu Betriebsbremse ≥ 5:1 **und** weniger als 1 % der Strecke mit Betriebsbremse gebremst.\n\n' +
            '- **0 %:** Verhältnis ≤ 0,5:1 **und** über 5,5 % der Strecke mit Betriebsbremse gebremst.\n\n' +
            '---\n\n' +
            '**Empfehlung:** Fahrer sollten möglichst häufig die Motorbremse oder den Retarder nutzen und vorausschauend fahren, um den Einsatz der Betriebsbremse zu minimieren – das verbessert sowohl die Bewertung als auch die Effizienz.\n\n' +
            'Basierend auf den folgenden Dokumenten:\n\n' +
            '1. [Perform Webinar 1 - Seite 4](https://fleetassistant-staging.rio.cloud/docs/language=DE/market=all/Perform_Webinar_1.pdf#page=4)\n' +
            '2. [Perform Webinar 1 - Seite 5](https://fleetassistant-staging.rio.cloud/docs/language=DE/market=all/Perform_Webinar_1.pdf#page=5)\n' +
            '3. [202602 Perform Ratings DE - Seite 5](https://fleetassistant-staging.rio.cloud/docs/language=DE/market=all/202602_Perform_Ratings_DE.pdf#page=5)\n' +
            '4. [Perform Webinar 1 - Seite 6](https://fleetassistant-staging.rio.cloud/docs/language=DE/market=all/Perform_Webinar_1.pdf#page=6)\n' +
            '5. [Perform Fahrerbewertung 1 - Seite 3](https://fleetassistant-staging.rio.cloud/docs/language=DE/market=all/Perform_Fahrerbewertung_1.pdf#page=3)',
        },
      ],
    },
  },

  'step-4': {
    messages: {
      role: 'ai',
      content: [
        {
          id: 'onb-6',
          timestamp: '2024-11-21T06:38:39.224384+00:00',
          role: 'human',
          threadId: ONBOARDING_THREAD_ID,
          content: 'Was kann mein Fahrer Bruno Ranft, der ein niedriges Bremsrating hat, tun, um sich zu verbessern?',
        },
        {
          id: 'onb-7',
          timestamp: '2024-11-21T06:39:09.224403+00:00',
          role: 'ai',
          threadId: ONBOARDING_THREAD_ID,
          data_visualization: {
            default_data_visualization: 'table',
          },
          content:
            'Für den Zeitraum vom 2. Juni 2026 bis 2. Juli 2026 weist Fahrer **Bruno Ranft** eine Bremsbewertung von lediglich **20,0 Punkten** auf. Dies ist ein deutliches Zeichen, dass erheblicher Verbesserungsbedarf besteht.\n\n' +
            '- **KPI** Fahrer Name: Bruno Ranft\n' +
            '- **KPI** Bewertung des Bremsverhaltens: 20.0\n\n' +
            '## Was bedeutet diese Bewertung?\n\n' +
            'Laut der Bewertungsmethodik wird die Bremsbewertung anhand von zwei Kriterien ermittelt:\n\n' +
            '- **Verhältnis verschleißfreie Bremse zur Betriebsbremse:** Eine Bewertung von 100 % wird erreicht, wenn das Verhältnis mindestens 5:1 beträgt (verschleißfreie Bremse zu Betriebsbremse). Bei einem Verhältnis von 0,5:1 oder schlechter sinkt die Bewertung auf 0 %.\n' +
            '- **Anteil der Betriebsbremse an der Gesamtfahrstrecke:** Weniger als 1 % der Strecke mit Betriebsbremse ergibt 100 %, über 5,5 % ergibt 0 %.\n\n' +
            'Eine Bewertung von 20 Punkten zeigt, dass Bruno Ranft die Betriebsbremse deutlich zu häufig und die verschleißfreien Bremssysteme (Motorbremse und Retarder) zu selten einsetzt.\n\n' +
            '## Konkrete Maßnahmen zur Verbesserung\n\n' +
            '**1. Verschleißfreie Bremsen konsequent nutzen**\n' +
            '- Den **Retarder** und die **Motorbremse** so früh und so oft wie möglich einsetzen, bevor die Betriebsbremse betätigt wird.\n' +
            '- Den Lenkstockschalter nutzen, um die Bremsleistung stufenweise zu erhöhen, anstatt sofort zur Betriebsbremse zu greifen.\n' +
            '- Für maximale Dauerbremsleistung: Taste 2 drücken, um den Retarder auf maximale Bremsleistung zuzuschalten.\n\n' +
            '**2. Vorausschauend fahren**\n' +
            '- Frühzeitig auf Hindernisse, Kurven, Kreuzungen und Geschwindigkeitsbegrenzungen reagieren, um den Bremsweg mit verschleißfreien Systemen zu verlängern und die Betriebsbremse zu entlasten.\n' +
            '- Ausreichend Abstand zum vorausfahrenden Fahrzeug halten, um rechtzeitig mit Motorbremse oder Retarder verzögern zu können.\n\n' +
            '**3. Betriebsbremse nur gezielt einsetzen**\n' +
            '- Die Betriebsbremse sollte nur dann genutzt werden, wenn verschleißfreie Bremssysteme nicht ausreichen – z. B. bei Notbremsungen oder sehr starken Gefällen.\n' +
            '- Ziel: Den Anteil der mit Betriebsbremse gebremsten Strecke auf unter 1 % der Gesamtfahrstrecke zu senken.\n\n' +
            '**4. Regelmäßige Selbstreflexion anhand des Fahrer-Detailberichts**\n' +
            '- Bruno Ranft sollte seinen wöchentlichen Fahrer-Detailbericht regelmäßig einsehen und sein Bremsverhalten im Vergleich zur Vorwoche analysieren.\n' +
            '- So lassen sich Fortschritte und verbleibende Schwachstellen gezielt identifizieren.\n\n' +
            '**5. MAN ProfiDrive Training in Betracht ziehen**\n' +
            '- Ein gezieltes Fahrertraining im Rahmen von **MAN ProfiDrive** kann helfen, die Fahrtechnik zu verbessern und die optimale Nutzung der Fahrzeugtechnik (Retarder, Motorbremse) zu trainieren.\n\n' +
            'Durch die konsequente Umsetzung dieser Maßnahmen kann Bruno Ranft sein Bremsrating deutlich steigern, den Verschleiß an der Betriebsbremse reduzieren und gleichzeitig zur Kraftstoffeffizienz der Flotte beitragen.\n\n' +
            'Basierend auf den folgenden Dokumenten:\n\n' +
            '1. [Perform Webinar 1 - Seite 6](https://fleetassistant-staging.rio.cloud/docs/language=DE/market=all/Perform_Webinar_1.pdf#page=6)\n' +
            '2. [Perform Webinar 1 - Seite 5](https://fleetassistant-staging.rio.cloud/docs/language=DE/market=all/Perform_Webinar_1.pdf#page=5)\n' +
            '3. [Perform Fahrerbewertung 1 - Seite 3](https://fleetassistant-staging.rio.cloud/docs/language=DE/market=all/Perform_Fahrerbewertung_1.pdf#page=3)\n' +
            '4. [TGL Betriebsanleitung - Seite 186](https://fleetassistant-staging.rio.cloud/docs/language=DE/market=all/TGL_Betriebsanleitung.pdf#page=186)',
        },
      ],
    },
  },
};
